/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, platform: NonNullable<unknown> }} Pc_Dl_Card_TitleInputs */

const en_pc_dl_card_title = /** @type {(inputs: Pc_Dl_Card_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft ${i?.version} for ${i?.platform}`)
};

const zh_pc_dl_card_title = /** @type {(inputs: Pc_Dl_Card_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft ${i?.version} ${i?.platform} 版`)
};

/**
* | output |
* | --- |
* | "PdfCraft {version} for {platform}" |
*
* @param {Pc_Dl_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_card_title = /** @type {((inputs: Pc_Dl_Card_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Card_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_card_title(inputs)
	return zh_pc_dl_card_title(inputs)
});
export { pc_dl_card_title as "pc.dl.card_title" }